import FormEditOrAssignPermissions from './formEditOrAssignPermissions';
import { useFormSearchUser } from '@/hooks/forms';
import { broadcastService } from '@/services';
import { CirclePlus } from 'lucide-react';
import { Button } from '@/components/ui';
import { useEmployees } from '../hooks';
import { notify } from '@/functions';

const ButtonAddUser = () => {

  const { employees, isLoading: isLoadingEmployees } = useEmployees();
  const { search } = useFormSearchUser();

  const handleOnClickBtnAdd = () => {
    search({
      description: 'Rechercher et ajouter un nouvel utilisateur en tant que employé',
      submitButtonTitle: 'Ajouter',
      title: 'Ajouter un employé',
      callback: async user => {

        if (employees.some(l => l._id === user._id)) {
          // Notify
          notify(`L'utilisateur est déjà défini.`, 'info');
          return;
        }

        // Show form ser set permissions
        broadcastService
          .modal
          .show({
            content: (
              <FormEditOrAssignPermissions
                employee={{
                  createdAt: user.createdAt,
                  username: user.username,
                  email: user.email,
                  _id: user._id,
                  roles: {
                    employee: true,
                    permissions: [],
                    root: false
                  }
                }} />
            ),
            fullScreenOnMobile: true,
            showCloseIcon: true,
            width: 'lg'
          });

        return Promise.resolve();
      }
    })
  };

  return (
    <div className='flex justify-end'>
      <Button
        disabled={isLoadingEmployees}
        variant={'secondary'}
        onClick={handleOnClickBtnAdd}
        title='Ajouter un utilisateur comme employé'
        className='my-auto space-x-1'>
        <CirclePlus size={16} />
        <span className='text-xs'>
          Ajouter
        </span>
      </Button>
    </div>
  );

};

export default ButtonAddUser;
